import { Injectable, OnDestroy } from "@angular/core";

@Injectable()
export class OwlDatepickerCustomizer implements OnDestroy {
  private calendarNativeElement: Element;
  private timerInputNativeElements: NodeListOf<Element>;
  private timerInputListener!: EventListener;
  private timerMousewheelListener!: EventListener;
  private calendarTabKeyDownListener!: EventListener;

  customizeOwlDateTimer(maxHr: number = 23, maxMin: number = 59): void {
    const inputs = document.querySelectorAll(
      'owl-date-time-container owl-date-time-timer input'
    );
    this.timerInputNativeElements = inputs;
    inputs?.forEach((input) => {
      input.setAttribute('type', 'number');
      input.setAttribute('min', '0');

      this.timerInputListener = this.onInput.bind(this);
      input.addEventListener('input', this.timerInputListener);

      this.timerMousewheelListener = this.onMousewheel.bind(this);
      input.addEventListener('mousewheel', this.timerMousewheelListener, {
        passive: true,
      });
    });

    //hr
    if (inputs[0]) {
      inputs[0].setAttribute('max', maxHr.toString());
    }
    //mn
    if (inputs[1]) {
      inputs[1].setAttribute('max', maxMin.toString());
    }

    this.calendarTabKeyDownListener = this.onCalendarTabKeyDown.bind(this);
    this.calendarNativeElement = document.querySelector(
      '.owl-dt-calendar-main'
    );
    this.calendarNativeElement?.addEventListener(
      'keydown',
      this.calendarTabKeyDownListener
    );

    this.setTabIndexForCancelButton(-1);
  }

  private setTabIndexForCancelButton(tabIndex: number) {
    const cancelBtn = document.querySelectorAll(
      '.owl-dt-container-row.owl-dt-container-buttons button'
    )[0];
    if (cancelBtn) {
      (cancelBtn as any).tabIndex = tabIndex;
    }
  }

  private onInput(event: InputEvent) {
    function disableSetButton(isDisabled: boolean): void {
      const setBtn = document.querySelectorAll(
        '.owl-dt-container-row.owl-dt-container-buttons button'
      )[1];
      if (setBtn) {
        (setBtn as any).disabled = isDisabled;
      }
    }

    const element = event.target as any;

    if (!element?.value) {
      disableSetButton(true);
      this.setTabIndexForCancelButton(0);
    } else {
      disableSetButton(false);
      //don't allow to tab to cancel button since date/time valid
      this.setTabIndexForCancelButton(-1);
    }

     if (+element?.value > +element?.max) {
       element.value = 0;
     }
  }

  private onCalendarTabKeyDown(event: KeyboardEvent): void {
    if (event.code === 'Tab') {
      event.preventDefault();
      const input = document.querySelector(
        'owl-date-time-container owl-date-time-timer input'
      );
      if (input) {
        //focus first input on tab
        (input as any).focus();
        (input as any).select();
      }
    }
  }

  stopSetButtonEnterKeyDownPropagation(): void {
    document
      .querySelectorAll(
        '.owl-dt-container-row.owl-dt-container-buttons button'
      )[1]
      .addEventListener('keydown', function (event) {
        if ((event as any).key === 'Enter') {
          event.stopPropagation();
        }
      });
  }

  setTime(hr: number, mn: number): void {
    const inputs = document.querySelectorAll('owl-date-time-container owl-date-time-timer input');
    if (inputs?.length && inputs.length == 2) {
      (inputs[0] as any).value = hr;
      (inputs[1] as any).value = mn;
    }
  }

  focus(): void {
    (document.querySelector('.cdk-focus-trap-anchor') as any)?.focus();
  }

  onMousewheel(event: WheelEvent) {
    //Don't remove! Zone needs this empty handler since it enables a native support of mousewheel for input[type="number"]
  }

  ngOnDestroy(): void {
    this.timerInputNativeElements?.forEach((node) => {
      node.removeEventListener('input', this.timerInputListener);
      node.removeEventListener('mousewheel', this.timerMousewheelListener);
    });
    this.calendarNativeElement?.removeEventListener(
      'keydown',
      this.onCalendarTabKeyDown
    );
  }
}
